module.exports = __webpack_public_path__ + "img/undraw_1.22f7413a.png";